import React, { useState } from "react";

import "./assets/css/Img.css"; // Importando o CSS personalizado

const ImageHospital = ({ images }) => {
    const [lightboxIndex, setLightboxIndex] = useState(0);
    const [lightboxOpen, setLightboxOpen] = useState(false);

    const openLightbox = (index) => {
        setLightboxIndex(index);
        setLightboxOpen(true);
    };

    const closeLightbox = () => {
        setLightboxOpen(false);
    };

    return (
        <div className="gallery-container">
            <ul className="clinic-gallery">
                {images.map((image, index) => (
                    <li key={index} className="gallery-item">
                        <img
                            width="10px" // 👈 Isso deixa as imagens muito pequenas
                            src={image.file}
                            alt={`Imagem ${index + 1}`}
                            className="gallery-img"
                            onClick={() => openLightbox(index)}
                        />

                    </li>
                ))}
            </ul>

            {lightboxOpen && (
                <Lightbox
                    mainSrc={images[lightboxIndex].file}
                    nextSrc={images[(lightboxIndex + 1) % images.length].file}
                    prevSrc={images[(lightboxIndex + images.length - 1) % images.length].file}
                    onCloseRequest={closeLightbox}
                    onMovePrevRequest={() =>
                        setLightboxIndex((lightboxIndex + images.length - 1) % images.length)
                    }
                    onMoveNextRequest={() =>
                        setLightboxIndex((lightboxIndex + 1) % images.length)
                    }
                    animationDuration={500}  // Animação suave
                />
            )}
        </div>
    );
};

export default ImageHospital;
